export default "<template>\n    <span id=\"icon\"> </span>\n</template>\n";